import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IUpdateSuspendedDataAlertSettingParams {
  user: string;
  enabled: boolean;
}

export class UpdateSuspendedDataAlertSettingRequest extends Request<IUpdateSuspendedDataAlertSettingParams, IResult> {
  constructor(params: IUpdateSuspendedDataAlertSettingParams) {
    super('updateSuspendedDataAlertNotificationSetting', params);
  }
}
